import type { IFilterOptions } from "@fluidattacks/design";

function filterDataset<T extends object>(
  dataset: T[],
  filters: readonly IFilterOptions<T>[],
): T[] {
  return dataset.filter((item): boolean =>
    filters.every((filter): boolean => {
      const filterValue = filter.value?.toString().toLowerCase() ?? "";
      const itemValue =
        (item[filter.key as keyof T] as unknown as string)
          .toString()
          .toLowerCase() || "";

      return itemValue.includes(filterValue);
    }),
  );
}

export { filterDataset };
